import * as z from "zod/v4";
import { ShopifyGraphQLProductSchema as ProductDataSchema } from "../../../product";

export const ProductExchangeRecommendationSchema = z.object({
  product: ProductDataSchema,
  recommendationMessage: z.string(),
});

export type ProductExchangeRecommendation = z.infer<
  typeof ProductExchangeRecommendationSchema
>;
